export default __webpack_public_path__ + "/assets/news-nav.png";